import { showSuccessNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/market/yandex'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class MarketYandexApi {

    static async loadCards({ data = { shop: undefined, offerIds: undefined, archive: undefined, onlyNew: undefined }, ...params }) {
        return await fetchService({ url: '/loadcards', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async loadPricesAndQuantum({ data = { shop: undefined, offerIds: undefined, onlyNew: undefined }, ...params }) {
        return await fetchService({ url: '/loadprices', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }




    static async getCardsBySearch({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined, limit: undefined, page: undefined, sort: undefined }, ...params }) {
        return await fetchService({ url: '/getcards', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeCard({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changecard', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async updateByExcel({ data = { shop: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/updatebyexcel', method: 'POST', data, ...params })
    }

    static async uploadStocksAndPrices({ data = { shop: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/uploadstocksandprices', method: 'POST', data, ...params })
    }

    static async excelStocksAndPricesTmp({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/exceltocksandpricestmp', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelStocksFbsActive({ data = { shop: undefined, search: undefined, tab: undefined, filters: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelstocksfbsactive', method: 'POST', data, options: { download: true }, ...params })
    }

    static async updateStocks({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/updatestocks', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async updatePrices({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/updateprices', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }




    static async changeMarginality({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changemarginality', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changePrice({ data = { shop: undefined, offer_id: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeprice', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changeStock({ data = { shop: undefined, skladName: undefined, offer_id: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changestock', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    // static async changeArchive({ data = { shop: undefined, offerIds: undefined, value: undefined }, ...params }) {
    //     return await fetchService({ url: '/changearchive', method: 'PATCH', data, ...params })
    //         .then(r => { showSuccessNotify(`${r.message}`); return r })
    // }

    static async changeStopBrand({ data = { shop: undefined, offerIds: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changestopbrand', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }




    static async excelData({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined }, ...params }) {
        return await fetchService({ url: '/exceldata', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelStocks({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined }, ...params }) {
        return await fetchService({ url: '/excelstocks', method: 'POST', data, options: { download: true }, ...params })
    }


}